// extracted by mini-css-extract-plugin
module.exports = {"button":"CommentModal_button_ZeChw","modal":"CommentModal_modal_16-RS"};